module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid grid-cols-3 w-full gap-x-3 gap-y-3 my-48"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": function($event) {
        _vm.show_create_premade_modal = true
      }
    }
  }, [_c('h1', {
    staticClass: "text-center text-blue-500 font-semibold uppercase text-lg"
  }, [_vm._v("Create Premade")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToSearchEditPremades
    }
  }, [_c('h1', {
    staticClass: "text-center text-blue-500 font-semibold uppercase text-lg"
  }, [_vm._v("Search and Edit Premades")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToAdminEditCollections
    }
  }, [_c('h1', {
    staticClass: "text-center text-blue-500 font-semibold uppercase text-lg"
  }, [_vm._v("Edit Collections")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToAdminUniverseSettings
    }
  }, [_c('h1', {
    staticClass: "text-center text-blue-500 font-semibold uppercase text-lg"
  }, [_vm._v("Edit Subjects / Grades / Skills")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-2 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToSchoolManagement
    }
  }, [_c('h1', {
    staticClass: "text-center text-blue-500 font-semibold uppercase text-lg"
  }, [_vm._v("Manage Schools / Districts / Memberships / Teachers")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToWelcomeModals
    }
  }, [_c('h1', {
    staticClass: "text-center flex-grow justify-center text-blue-500 font-semibold uppercase text-lg align-middle"
  }, [_vm._v("Welcome Modals")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 rounded border border-solid py-6 px-4 cursor-pointer hover:bg-gray-200",
    on: {
      "click": _vm.goToGeniePrompts
    }
  }, [_c('h1', {
    staticClass: "text-center flex-grow justify-center text-blue-500 font-semibold uppercase text-lg align-middle"
  }, [_vm._v("Genie Prompts")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-blue-500 px-5 py-2 rounded text-whie font-medium text-white",
    on: {
      "click": function($event) {
        return _vm.signOut()
      }
    }
  }, [_vm._v("Log Out")])]), _vm._v(" "), (_vm.show_create_premade_modal) ? _c('create-premade-modal', {
    on: {
      "close": function($event) {
        _vm.show_create_premade_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-42af7fea!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminDashboard.vue
// module id = 1399
// module chunks = 61